import { render, staticRenderFns } from "./ClaimsCheck.vue?vue&type=template&id=235a9e42&scoped=true"
import script from "./ClaimsCheck.vue?vue&type=script&lang=ts"
export * from "./ClaimsCheck.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsCheck.vue?vue&type=style&index=0&id=235a9e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a9e42",
  null
  
)

export default component.exports